import React, { useEffect, useState } from 'react';
import { fetchQuoteDefaults } from '../../database/fetch-quote-defaults';
import { setQuoteDefaults } from '../../database/set-quote-defaults';

const QuoteDefaultsModal = ({ open, setOpen }) => {
  const [marginDefault, setMarginDefault] = useState(0);
  const [gAndADefault, setGAndADefault] = useState(0);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    (async () => {
      const { marginDefault, gAndADefault } = await fetchQuoteDefaults();
      setMarginDefault(marginDefault);
      setGAndADefault(gAndADefault);
    })();
  }, [open]);

  const onSave = async () => {
    setSaving(true);
    await setQuoteDefaults({ marginDefault, gAndADefault });
    setSaving(false);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Set Margin & G&A Defaults</h3>
          <button className="text-gray-400 hover:text-gray-600" onClick={() => setOpen(false)}>✕</button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Default Margin (%)</label>
            <input
              type="number"
              value={marginDefault}
              onChange={(e) => setMarginDefault(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2"
              placeholder="e.g., 15"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Default G & A ($)</label>
            <input
              type="number"
              value={gAndADefault}
              onChange={(e) => setGAndADefault(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2"
              placeholder="e.g., 25"
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button className="px-4 py-2 rounded border" onClick={() => setOpen(false)}>Cancel</button>
          <button disabled={saving} className="px-4 py-2 rounded bg-blue-600 text-white" onClick={onSave}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuoteDefaultsModal;


